<template>
  <teleport to="body">
    <div class="dialog" @click.self="closeDialog">
      <div class="dialog-main">
        <span class="closeIcon" @click.stop="closeDialog">×</span>
        <video class="scene-img" :src="currSceneInfo.videoUrl" controls autoplay muted :poster="currSceneInfo.bgUrl"
          controlslist="nodownload noremoteplayback" disablePictureInPicture v-if="dataType==='video'">
        </video>
        <img class="scene-img" :src="currSceneInfo.videoUrl" alt="" v-else>
        <div class="scene-des">
          {{currSceneInfo.description}}
        </div>
        <div class="btn-wrap">
          <button class="btn" @click="preview">查看案例</button>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script>

export default {
  props: ['currSceneInfo'],
  emits: ['hideDialog'],
  setup (props, ctx) {
    const closeDialog = () => {
      ctx.emit('hideDialog')
    }
    const preview = () => {
      closeDialog()
      window.open(props.currSceneInfo.linkUrl)
    }
    return {
      closeDialog,
      preview
    }
  },
  computed: {
    dataType () {
      const arr = this.currSceneInfo.videoUrl.split('.')
      return arr[1] === 'mp4' ? 'video' : 'image'
    }
  }

}
</script>

<style  lang="scss" scoped>
.dialog {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
}
.dialog-main {
  background: #1d262e;
  border: 2px solid #96a9b9;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 800px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  .scene-img {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 800px;
    height: 450px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .scene-des {
    margin: 20px;
    font-size: 18px;
    line-height: 25px;
    color: #fff;
  }
  .btn-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    .btn {
      width: 112px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      height: 30px;
      background: linear-gradient(270deg, #2ab2f9 0%, #0c6ff6 100%);
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
.closeIcon {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 20px;
  text-align: center;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  cursor: pointer;
  &:hover {
    color: #2ab2f9;
    background-color: rgba(0, 0, 0, 0.8);
  }
}
</style>
